<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<!--p-blockUI [target]="pnl" [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI-->

<div class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Regresar" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
            <!--button pButton pRipple label="Agregar" icon="pi pi-plus" class="p-button-success p-mr-2"
                (click)="openNew()"></button-->
            
        </ng-template>

        <!--ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template-->
    </p-toolbar>
    <p-table #dt [value]="lstGuides" [(selection)]="selectedGuide" dataKey="certif" styleClass="p-datatable-customers"
        [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]"
        [loading]="loading" [paginator]="true" [resizableColumns]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
        [globalFilterFields]="['certif','name','gender','currJob','localCountry','localState','localCity']">
        <ng-template pTemplate="caption">
            
            <div class="table-header">
                List of Guides
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Global Search" />
                </span>
            </div>
            <div class="p-d-flex">
                <!--button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV()" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button-->
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
    
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Cert.
                        <p-columnFilter type="text" field="certif" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Name 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Gender 
                        <p-columnFilter type="text" field="gender" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Job 
                        <p-columnFilter type="text" field="currJob" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Lang 
                        <p-columnFilter type="text" field="firstLang" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        B Year 
                        <p-columnFilter type="text" field="birYear" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        B Mon
                        <p-columnFilter type="text" field="birMont" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        B Day
                        <p-columnFilter type="text" field="birDay" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        S Year
                        <p-columnFilter type="text" field="sentYear" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        S Mon
                        <p-columnFilter type="text" field="sentMont" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        S Day
                        <p-columnFilter type="text" field="sentDay" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Phone
                        <p-columnFilter type="text" field="mobPhon" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Email
                        <p-columnFilter type="text" field="email" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        Country
                        <p-columnFilter type="text" field="localCountry" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        State
                        <p-columnFilter type="text" field="localState" display="menu"></p-columnFilter>
                    </div>
                </th>

                <th pResizableolumn>
                    <div class="p-d-flex p-jc-between p-ai-center">
                        City
                        <p-columnFilter type="text" field="localCity" display="menu"></p-columnFilter>
                    </div>
                </th>

            </tr>
            
       
            

        </ng-template>
        <ng-template pTemplate="body" let-guide>
            <tr>
                <td>
                    {{guide.certif}}
                </td>
                <td>
                    {{guide.name}}
                </td>
                <td>
                    {{guide.gender}}
                </td>
                <td>
                    {{guide.currJob}}
                </td>
                <td>
                    {{guide.firstLang}}
                </td>
                <td>
                    {{guide.birYear}}
                </td>
                <td>
                    {{guide.birMont}}
                </td>
                <td>
                    {{guide.birDay}}
                </td>
                <td>
                    {{guide.sentYear}}
                </td>
                <td>
                    {{guide.sentMont}}
                </td>
                <td>
                    {{guide.sentDay}}
                </td>
                <td>
                    {{guide.mobPhon}}
                </td>
                <td>
                    {{guide.email}}
                </td>
                <td>
                    {{guide.localCountry}}
                </td>
                <td>
                    {{guide.localState}}
                </td>
                <td>
                    {{guide.localCity}}
                </td>
                
                
                <!--td>
                    <span class="p-column-title">Coordinador</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.coordinator == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.coordinator == '0'"></button>
                </td>
                <td>
                    <span class="p-column-title">Secretario</span>
                    <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded p-button-text"
                        *ngIf="document.secretary == '1'"></button>
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-danger p-button-text"
                        *ngIf="document.secretary == '0'"></button>
                </td-->
                
                


                
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8">No document found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>

